import React from "react";

// Each current admin screen owns the shared Sidebar and TopBar so it can
// control its responsive navigation state.  Keeping this wrapper transparent
// prevents a second sidebar/header from being rendered around those screens.
export default function AdminLayout({ children }) {
  return children;
}
